import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import { reportRuntimeIncident } from './lib/runtimeLog.js';
import './styles.css';

window.addEventListener('error', (event) => {
  reportRuntimeIncident({
    title: '未捕获的脚本错误',
    detail: event.message,
    action: '已记录；物理仿真线程继续运行',
  });
});

window.addEventListener('unhandledrejection', (event) => {
  reportRuntimeIncident({
    title: '未处理的异步异常',
    detail: String(event.reason?.message ?? event.reason ?? '未知错误'),
    action: '已记录并隔离，可继续操作',
  });
});

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
